import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { getSubjectShortLabel } from '../../utils/dseSubjects';

export default function JupasSurveySyncModal({ open, conflicts, onChooseLocal, onChooseAccount }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open || typeof document === 'undefined') return null;

  return createPortal(
    <div className="fixed inset-0 z-[150] flex items-center justify-center bg-black/55 px-4 py-8" role="presentation">
      <section
        className="w-full max-w-lg rounded-2xl border border-edge bg-surface-elevated p-6 text-left shadow-2xl sm:p-7"
        role="dialog"
        aria-modal="true"
        aria-labelledby="jupas-survey-sync-title"
        aria-describedby="jupas-survey-sync-description"
      >
        <h2 id="jupas-survey-sync-title" className="text-xl font-bold text-ink sm:text-2xl">
          {t('jupasListSubmission.sync.title')}
        </h2>
        <p id="jupas-survey-sync-description" className="mt-3 text-sm leading-6 text-ink-muted">
          {t('jupasListSubmission.sync.body')}
        </p>

        {conflicts?.length ? (
          <ul className="mt-4 space-y-2 rounded-xl border border-edge bg-surface-muted/40 p-3 text-sm">
            {conflicts.map(({ code, local, account }) => (
              <li key={code} className="flex items-center justify-between gap-3">
                <span className="font-semibold text-link">{getSubjectShortLabel(t, code)}</span>
                <span className="tabular-nums text-ink-muted">
                  {t('jupasListSubmission.sync.conflictRow', { local, account })}
                </span>
              </li>
            ))}
          </ul>
        ) : null}

        <div className="mt-6 grid gap-2 sm:grid-cols-2">
          <button
            type="button"
            onClick={onChooseLocal}
            className="rounded-lg bg-primary px-4 py-2.5 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {t('jupasListSubmission.sync.useFilled')}
          </button>
          <button
            type="button"
            onClick={onChooseAccount}
            className="rounded-lg border border-edge-strong px-4 py-2.5 text-sm font-semibold text-ink transition-colors hover:bg-surface-muted focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {t('jupasListSubmission.sync.useAccount')}
          </button>
        </div>
      </section>
    </div>,
    document.body
  );
}
